export default "__VITE_ASSET__B88rwhw2__"